import 'regenerator-runtime/runtime';

async function onLoginSuccess(res) {
  // check if user profile valid, can later be used to grab permissions if needed
  let verifyResult = await fetch(`https://www.googleapis.com/admin/directory/v1/users/${res.googleId}?projection=full&viewType=domain_public`, {
    headers: { 'Authorization': `Bearer ${res.accessToken}` }
  });
  if (verifyResult.ok) {
    localStorage.setItem("token", res.accessToken);
    localStorage.setItem("googleId", res.googleId);
    window.location.reload(false);
  }
  else {
    console.log("Could not verify google profile: " + verifyResult);
  }
}

const onLoginFailure = (res) => {
  console.log('Login failed: ', res);
}

const onLogoutSuccess = () => {
  window.location.reload(false);
};

const onRequestFailure = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user_email");
  localStorage.removeItem("granular_permissions");
  window.location.reload();
}

export { onLoginSuccess, onLoginFailure, onLogoutSuccess, onRequestFailure };
